import niceNum from './niceNum';

function niceNumFromFen(value) {
  var re = '';
  if (!value && value != '0') {return re;}
  value = parseFloat(value);
  re = niceNum(value / 100);
  return re;
}

export default niceNumFromFen;



// WEBPACK FOOTER //
// ./node_modules/bjxy-common/filters/niceNumFromFen.js